import React from 'react';
import PropTypes from 'prop-types';

function R2Button({ activeColor, color, value }) {
  return (
    <>
      <path
        d="M686.198 102.522C686.198 102.522 653.958 95.2445 636.09 92.9539C618.228 90.6633 587.487 89.0804 587.487 89.0804C587.487 89.0804 596.121 46.2701 598.72 39.4314C601.322 32.5928 609.05 19.8281 619.046 14.6258C629.048 9.42345 632.278 6.39869 643.058 7.78071C653.831 9.16272 667.61 17.2173 674.935 32.8936C682.259 48.5699 686.198 102.522 686.198 102.522Z"
        fill={color}
      />
      <path
        d="M686.198 102.522C686.198 102.522 653.958 95.2445 636.09 92.9539C618.228 90.6633 587.487 89.0804 587.487 89.0804C587.487 89.0804 596.121 46.2701 598.72 39.4314C601.322 32.5928 609.05 19.8281 619.046 14.6258C629.048 9.42345 632.278 6.39869 643.058 7.78071C653.831 9.16272 667.61 17.2173 674.935 32.8936C682.259 48.5699 686.198 102.522 686.198 102.522Z"
        fill={activeColor}
        stroke={activeColor}
        strokeWidth="3px"
        style={{ opacity: value }}
      />
    </>
  );
}

R2Button.propTypes = {
  activeColor: PropTypes.string,
  color: PropTypes.string,
  value: PropTypes.number,
};

R2Button.defaultProps = {
  activeColor: '#FFFFFF',
  color: '#1A1A21',
  value: 0,
};

export default R2Button;
